export const uploadPreview = (node: HTMLImageElement, file: Blob) => {
	const reader = new FileReader();

	reader.onload = (event: ProgressEvent<FileReader>) => {
		const result = event.target?.result;
		if (typeof result === 'string') {
			node.src = result;
		}
	};

	reader.readAsDataURL(file);
};
